type NutakuWindow = Window & {
    NutakuGI?: {
        setIframeSize?: (height: number) => void;
    };
};

const getNutaku = () => {
    return (window as NutakuWindow).NutakuGI;
};

export const calculateNutakuIframeHeight = () => {
    return Math.round(window.screen.availHeight * 0.85);
};

export const canResizeNutakuIframe = () => {
    return Boolean(getNutaku()?.setIframeSize);
};

export const resizeNutakuIframe = () => {
    const nutaku = getNutaku();

    if (!nutaku?.setIframeSize) {
        return false;
    }

    nutaku.setIframeSize(calculateNutakuIframeHeight());
    return true;
};
